import React from "react";

const AboutUs = () => {
  return (

    <div id="about" >
      <div className="w-full  p-4 md:p-5 bg-gray-100  flex items-center justify-center" >
        <div className="text-left md:text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">About <span className="text-blue-900">US</span></h2>

          <p className="text-base md:text-lg text-gray-700 mb-8 ">
            Welcome to our premier real estate agency, founded and led by <strong>Mr. Ravi  Nai, Civil Engineer</strong> with 8+ years of experience in the civil field.
            Our mission is to provide exceptional service and expert guidance to help clients achieve their real estate goals.
            With years of industry experience, our dedicated team has built a reputation for excellence, integrity, and personalized support.

            <br />
            <br />

            Structural Integrity Analysis: We go beyond surface aesthetics. We assess properties with an engineer's eye, offering insights into construction quality, structural health, and potential future maintenance costs that standard agents might overlook.
            <br /><br />

            True Valuation & Cost Assessment: Our technical knowledge allows for a more accurate evaluation of property potential, especially for new builds, renovations, or land development. We help you understand the true value and cost implications of your investment.
            <br /><br />
            Whether you are buying or selling, you benefit from expert diligence on zoning compliance, permits, and building code adherence, minimizing unexpected issues down the road.
            With Ravi Nai and our team, you're not just getting a real estate agent; you're gaining a technical partner committed to securing a structurally sound and financially intelligent investment.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
































